import { useAuth } from 'react-oidc-context';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthGate } from './auth/AuthGate';
import { Layout } from './components/Layout';
import { setTokenGetter } from './api/client';
import { Dashboard } from './pages/Dashboard';
import { OpsDevices } from './pages/OpsDevices';
import { OpsDeviceGroups } from './pages/OpsDeviceGroups';
import { DeviceDetail } from './pages/DeviceDetail';
import { DeviceLocationHistory } from './pages/DeviceLocationHistory';
import { DeviceSessionsForDay } from './pages/DeviceSessionsForDay';
import { DeviceSessionTimeline } from './pages/DeviceSessionTimeline';
import { DeviceTelemetry } from './pages/DeviceTelemetry';
import { AuthCallback } from './pages/AuthCallback';
import { Analytics } from './pages/Analytics';
import { AdminUsers } from './pages/AdminUsers';
import { ContentLibrary } from './pages/ContentLibrary';
import { Releases } from './pages/Releases';
import { FleetMap } from './pages/FleetMap';

export default function App() {
  const auth = useAuth();

  // Wire the API client to the current ID token synchronously, BEFORE any
  // child component mounts. A useEffect runs after children's effects, so
  // their first query fires without an Authorization header. Setting the
  // module-level getter during render avoids the race entirely.
  setTokenGetter(() => auth.user?.id_token);

  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <AuthGate>
            <Layout />
          </AuthGate>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/devices" element={<Navigate to="/" replace />} />
        <Route path="/devices/:id" element={<DeviceDetail />} />
        <Route path="/devices/:id/telemetry" element={<DeviceTelemetry />} />
        <Route path="/devices/:id/locations" element={<DeviceLocationHistory />} />
        <Route path="/devices/:id/sessions" element={<DeviceSessionsForDay />} />
        <Route path="/devices/:id/sessions/:sessionId" element={<DeviceSessionTimeline />} />
        <Route path="/ops/devices" element={<OpsDevices />} />
        <Route path="/ops/device-groups" element={<OpsDeviceGroups />} />
        <Route path="/map" element={<FleetMap />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/content" element={<ContentLibrary />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function NotFound() {
  return (
    <div className="card max-w-md">
      <h2 className="font-semibold mb-1">Page not found</h2>
    </div>
  );
}
